<template>
  <div id="app" class="min-h-screen bg-gray-200 dark:bg-dark-bg" :key="`dark-${isDark}`">
    <header class="bg-white shadow dark:bg-dark-bg">
      <nav class="container mx-auto p-4 flex justify-between items-center w-full max-w-7xl">
        <router-link to="/" class="text-xl font-bold text-blue-700 dark:text-dark-text flex items-center">
          <img class="w-6 me-2 h-6" :src="appLogo" alt="App Logo"/>
          <span class="font-simbold text-2xl">{{ AppName }}</span>
        </router-link>
        <div class="flex gap-5 items-start cursor-pointer" v-if="isLoggedIn">
          <div class="flex  dark:text-dark-text pt-0.5">
            <Dark v-if="!isDark" @click="switchToDark" v-tooltip="'Dark Mode'"/>
            <Light v-if="!!isDark" @click="switchToLight" v-tooltip="'Light Mode'"/>
          </div>
          <AppMenu/>
        </div>
      </nav>
    </header>
    <main class="container mx-auto p-4 max-w-[1100px] max-sm:px-2 min-h-[89vh]">
      <router-view></router-view>
      <app-loader/>
    </main>
    <div class="flex bg-white w-full p-4 shadow mt-4 dark:bg-dark-bg">
      <div
          class="container mx-auto flex justify-between items-center w-full max-w-7xl text-2xs text-blue-800 font-bold italic dark:text-dark-text  xs:flex-col">
        <span>Powered by foodics</span>
        <span class="flex">Made with ♥️ by Muntaser - RMS Frontend</span>
      </div>
    </div>
  </div>
</template>

<script>
import AppLoader from "@/components/AppLoader";
import AppMenu from "@/components/Menu";
import Storage from "@/library/storage";
import AppStore from "@/store/app";
import axios from "@/library/request";
import Dark from '@/assets/dark.vue'
import Light from '@/assets/light.vue'

export default {
  name: 'App',
  components: {
    AppLoader,
    AppMenu,
    Dark,
    Light
  },
  data: () => ({
    // appLogo: require('@/assets/logo.png'),
    appLogo: require('@/assets/logo.jpg'),
    darkMode: false,
  }),
  computed: {
    AppName() {
      return process?.env?.VUE_APP_NAME
    },
    isLoggedIn() {
      return !!AppStore?.session;
    },

    isDark: ({
      get() {
        return this.darkMode
      },

      set(value = false) {
        this.darkMode = value;
        localStorage.setItem("isDark", `${ value }`)
      }
    }),

    hasToBeDark() {
      return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches && !localStorage.getItem("isDark");
    }
  },
  created() {
   this.initTheme()
  },
  beforeMount() {
    this.fetchMe();
    this.setUserSession();
    if (this.hasToBeDark && !this.isDark) {
      this.switchToDark();
    }
  },
  methods: {
    initTheme() {
      if(localStorage.getItem("isDark") === "true") {
        this.isDark = true;
      }

      if (this.isDark) {
        this.switchToDark();
      }
    },
    switchToDark() {
      document.body.classList.add("dark");
      this.isDark = true;
    },

    switchToLight() {
      document.body.classList.remove("dark");
      this.isDark = false;
    },

    setUserSession() {
      if (Storage.get('USER_SESSION')) {
        AppStore.session = Storage.get('USER_SESSION');
      }
    },
    fetchMe() {
      // fetch user's information'
      if (!Storage.get('USER_SESSION')) {
        return
      }

      const session = Storage.get('USER_SESSION');
      axios.post('auth/me').then((user) => {
        AppStore.session = {
          ...session,
          user: {
            ...user
          }
        }
      })
    }

  }
}
</script>

